import { RelocationRecord } from "@/app/Relocations/GraphQL/relocationRecordQuery";
import { getRelocationUpdateInput } from "@/app/Relocations/Utils/getRelocationUpdateInput";
import { GapRentalFormValues } from "@/app/GapRentals/Utils/getDefaultGapRentalValues";
import {
  getGapRentalDistanceMode,
  getGapRentalDistanceValue,
} from "@/app/GapRentals/Utils/gapRentalDistance";

/**
 * Gap rentals are stored as relocations, so the saved record maps across
 * unchanged apart from distance: the two stored allowances become the mode and
 * single number the form edits.
 */
export function getGapRentalUpdateInput(
  relocation: RelocationRecord,
): GapRentalFormValues {
  return {
    ...getRelocationUpdateInput(relocation),
    distance_mode: getGapRentalDistanceMode(relocation),
    distance_value: getGapRentalDistanceValue(relocation),
  };
}
